import React, { Component } from "react";
import styles from "./cmsExceptions.module.scss";
import { withAuth } from "../../../shared/containers/containerAuth";
import { withExceptions } from "../../../shared/containers/containerExceptions";
import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";
import Scrollbars from "react-custom-scrollbars-2";
import getDates from "../../../shared/services/date.service";
import Icon from "../../../shared/items/static/icon";
import InputMask from "react-input-mask";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import DeleteIcon from "@mui/icons-material/Delete";

let searchTimeOutId = null;

class CmsExceptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selextIndex: 0,
      searchTerm: null,
    };
  }

  componentDidMount() {
    const { data, onGetExceptions } = this.props;

    if (data.permissions.includes(55001)) {
      onGetExceptions({});
    }
  }

  onChangeSearchTerm(e) {
    const { onGetExceptions } = this.props;

    clearTimeout(searchTimeOutId);
    this.setState({ searchTerm: e.target.value });

    searchTimeOutId = setTimeout(() => {
      const { searchTerm } = this.state;

      onGetExceptions({ searchTerm });
    }, 600);
  }

  onDeleteClick() {
    const { onDeleteExceptions, exceptions } = this.props;
    const { searchTerm, selextIndex } = this.state;

    onDeleteExceptions({ searchTerm, id: exceptions.modules[selextIndex].id });
  }

  render() {
    const { data, exceptionsDataState, exceptions, exceptionsDeleteDataState } = this.props;
    const { selextIndex, searchTerm } = this.state;

    if (!data.permissions.includes(55001) || exceptions === null) {
      return <div></div>;
    }

    const height = window.innerHeight - 160;

    const modules = exceptions.modules.map((module) => {
      return module;
    });

    return (
      <div style={{ height: `${height}px` }}>
        <div className={styles.tabsContainer}>
          {modules.map((module, index) => {
            return (
              <div
                key={index}
                className={selextIndex === index ? styles.cmsTabActive : styles.cmsTab}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ selextIndex: index });
                }}
              >
                {module.title} {module.exceptions.length}
              </div>
            );
          })}
        </div>

        <div className={styles.toolContainer}>
          <div className={styles.searchToolsContainer}>
            <div className={styles.inputStyle}>
              <InputMask type={"text"} placeholder={"Поиск"} onChange={this.onChangeSearchTerm.bind(this)} value={searchTerm} />
            </div>

            <div className={styles.container_searchBtn}>
              <Icon name="search" />
            </div>
          </div>
          <div className={styles.deleteToolContainer}>
            <TooltipWrapper title={`Удалить записи ошибок`} position="top">
              <DeleteIcon
                fontSize="large"
                onClick={(e) => {
                  e.stopPropagation();
                  if (exceptionsDeleteDataState !== states.REQUEST) {
                    this.onDeleteClick();
                  }
                }}
              />
            </TooltipWrapper>
          </div>
        </div>

        {exceptionsDataState === states.REQUEST || exceptionsDeleteDataState === states.REQUEST ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Preloader />
          </div>
        ) : (
          <Scrollbars ref="scrollbar" style={{ height: `${height - 120}px` }} autoHide={false}>
            {modules[selextIndex].exceptions.map((item) => {
              return (
                <div key={item.id} className={styles.exeptionContainer}>
                  <div className={styles.exeptionBlock}>
                    <div>
                      <span>{getDates.getDateFormat3(item.timeStamp)}</span>
                    </div>
                    <div className={styles.exeptionMessageContainer}>
                      <div className={styles.exeptionBlock}>
                        <b>Сообщение: </b>
                      </div>
                      <div>
                        {item.message.split("\\r\\n").map((x, i) => {
                          return <div key={i}>{x}</div>;
                        })}
                      </div>
                    </div>
                    <div className={styles.exeptionMessageContainer}>
                      <div className={styles.exeptionBlock}>
                        <b>Трассировка стека: </b>
                      </div>
                      <div>
                        {item.stackTrace.split("\n").map((x, i) => {
                          return <div key={i}>{x}</div>;
                        })}
                      </div>
                    </div>
                  </div>

                  {item.unit !== null ? (
                    <div className={styles.exeptionBlock}>
                      <div>{item.unit.company.title}</div>
                      <div>
                        {item.unit.title} {item.unit.registerNumber}
                      </div>
                      <div>{item.unit.device.imei}</div>
                      <div>
                        {item.unit.device.type} {item.unit.device.model}
                      </div>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </Scrollbars>
        )}
      </div>
    );
  }
}

export default withExceptions(withAuth(React.memo(CmsExceptions)));
